import TitleFlex from './TitleFlex'

export default TitleFlex
